import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/orpc/client';
export function useListMessages() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = orpc.message.list.infiniteOptions({
      input: _temp,
      initialPageParam: undefined,
      getNextPageParam: _temp2,
      placeholderData: keepPreviousData
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useInfiniteQuery(t0);
}
function _temp2(lastPage) {
  return lastPage.nextCursor;
}
function _temp(pageParam) {
  return {
    cursor: pageParam
  };
}
export function useCreateMessage(onSuccess) {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== onSuccess || $[1] !== queryClient) {
    t0 = orpc.message.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.message.list.key()
        });
        onSuccess?.();
      }
    });
    $[0] = onSuccess;
    $[1] = queryClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useMutation(t0);
}
export function useDeleteMessage(onSuccess) {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== onSuccess || $[1] !== queryClient) {
    t0 = orpc.message.delete.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.message.list.key()
        });
        onSuccess?.();
      }
    });
    $[0] = onSuccess;
    $[1] = queryClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useMutation(t0);
}